.DataTableButton {
  --button-border-color: var(--neutral);
  --button-background-color: var(--white);
  --button-color: var(--neutral);

  cursor: pointer;
  margin: auto;
  border: 1px solid var(--button-border-color);
  border-radius: 100%;
  width: 18px;
  height: 18px;
  background-color: var(--button-background-color);
  color: var(--button-color);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.1s ease-in-out;

  svg {
    width: 14px;
    height: 14px;
  }

  &:focus-visible,
  &:global(.focus-visible) {
    outline: 2px solid var(--primary);
    outline-offset: 2px;
  }
}

.color-accent-2 {
  &:hover,
  &:focus-visible,
  &:global(.focus-visible) {
    --button-border-color: var(--accent-2);
    --button-background-color: var(--accent-2);
    --button-color: var(--white);
  }
}

.color-neutral {
  --button-border-color: var(--neutral-1);
  --button-color: var(--neutral-1);

  &:hover,
  &:focus-visible,
  &:global(.focus-visible) {
    --button-border-color: var(--neutral);
    --button-background-color: var(--neutral);
    --button-color: var(--white);
  }
}
